import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, first, Observable, Subject } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { ExcelDownloadService } from '../shared/services/excel-download.service';
import { B2bUserService } from "../shared/services/b2b-user.service";
import { toObservable } from "@angular/core/rxjs-interop";

@Injectable({
  providedIn: 'root',
})
export class AccountOverviewService {
  private readonly b2bUserService = inject(B2bUserService);

  private userAccountIdDetailsData = new BehaviorSubject<any>(null);
  private $b2bUnit: Observable<any>;

  public userAccountIdDetailsData$ = this.userAccountIdDetailsData.asObservable();

  constructor(
    private readonly baseService: BaseService,
    public readonly excelService: ExcelDownloadService
  ) {
    this.$b2bUnit = toObservable(this.b2bUserService.b2bUser);
  }

  public getAccountId() {
    this.userAccountIdDetailsData.next(null);

    this.$b2bUnit
      .pipe(
        first(Boolean)
      )
      .subscribe((res) => {
        this.userAccountIdDetailsData.next(res);
      });
  }

  public downloadXls(data, name, filenameNoChange = true) {
    this.excelService.exportAsExcelFile(data, name, filenameNoChange);
  }
}
